module.exports = __webpack_public_path__ + "img/icon_login.67d9543e.svg";